import { render, staticRenderFns } from "./CouponEditor.vue?vue&type=template&id=8ef3c1ec&scoped=true&"
import script from "./CouponEditor.vue?vue&type=script&lang=js&"
export * from "./CouponEditor.vue?vue&type=script&lang=js&"
import style0 from "./CouponEditor.vue?vue&type=style&index=0&id=8ef3c1ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef3c1ec",
  null
  
)

export default component.exports